<template>
    <div class="Home container">
        <Btn></Btn>
        <Card>
            <div class="cardWrapper mt-2">
                <div @click="$router.go(-1)"  class="kembali backBtn text-blue mb-3"><i class="fas fa-chevron-left"></i> Kembali</div>
                <form @submit.prevent="forgotPass">
                    <label for="sandi">Kata Sandi</label>
                    <div class="btn-group-icon blue">
                    <input name="sandi" class="input-outline" type="password" >
                    <div class="underline"></div>
                    </div>
                    <label for="resandi">Ulangi Kata Sandi</label>
                    <div class="btn-group-icon blue">
                    <input name="resandi" class="input-outline" type="password" >
                    <div class="underli"></div>
                    </div>
                    <button class="btn-fill blue rounded mt-2">Ubah Password</button>
                    <!-- <button @click="$router.go(-1)" class="btnBackBottom btn-outline blue rounded">Kembali</button> -->
                </form>
            </div>
        </Card>
        <Loader v-if="isLoad"/>
    </div>
</template>

<script>
import Card from '../components/cardCenter.vue'
import Btn from '../components/backBtn.vue'
import Loader from '../components/loader.vue'
import axios from 'axios'
export default {
  components: {
    Card,
    Btn,
    Loader
  },
  data () {
    return {
      isLoad: false,
      form: {
        number: ''
      }
    }
  },
  methods: {
    async forgotPass () {
      try {
        this.isLoad = true
        const forgotPass = await axios.get(`auth/otp?number=${this.form.number}`)
        this.logger(forgotPass)
        this.isLoad = false
        this.$router.push({ name: 'Verifikasi', params: { number: this.form.number, type: 'forgotPassword' } })
      } catch (err) {
        this.logger(err)
        this.isLoad = false
        if (err.response && err.response.data === 'Bad mobile number format') {
          // this.err.number = 'Nomor hp tidak valid'
          this.alertFailed('Nomor hp tidak valid')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/scss/Layout/home.scss';
</style>
